import { FlisItemTypeCount } from '@/api/generatedApi';
import { useDebouncedValue } from '@/hooks/useDebouncedValue';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

const SEARCH_DEBOUNCE_MS = 300;
export const MIN_ITEM_TYPE_SEARCH_LENGTH = 3;

export const useSearchPartImageItemTypes = (search: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const debounced = useDebouncedValue(search.trim(), SEARCH_DEBOUNCE_MS);
  return useQuery<FlisItemTypeCount[], AxiosApiError>({
    queryKey: ['partImageItemTypes', tenantId, debounced],
    queryFn: async () => {
      const response = await api.tenants.searchPartImageItemTypes(tenantId, debounced);
      return response.data.itemTypes;
    },
    enabled: !!tenantId && debounced.length >= MIN_ITEM_TYPE_SEARCH_LENGTH,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
};
